// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.black-rounded-button{
    background-color:black !important;
    color:white !important;
    border-radius: 50px;
    border-color: transparent !important;
    text-align: center !important;
}
.black-scan-btn{
    background-color:black !important;
    color:white !important;
    border-color: transparent !important;
    text-align: left;
}
.white-scan-btn{
    background-color:white !important;
    color:black !important;
    border-color: transparent !important;
    text-align: left;
}

.black-scan-btn:disabled{
    color: white !important ;
    background-color: gray !important;
}

.alter-order-button{
    border:0 !important ;
    height: 18px !important ;
    padding: 0 3px !important ;
    /*background-color: rgba(0,0,0,0) !important ;*/
    color: white !important ;
    background-color: gray !important;
}

.rounded-button{
    border-radius: 50px;
}

.change-order-button{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 5px;
}

.scan-btn{
    /*border-radius: 50px;*/
    width: 10vw;
    text-align: left;
}

.custom-large-badge > .ant-badge-status-dot {
    width: 9px;
    height: 9px;
}
/* .ant-progress-circle-path{
    stroke: #3ECD32 !important;
} */

.ant-badge-status-processing::after {
    
    animation: antStatusProcessing 1.2s infinite cubic-bezier(0.68, -0.55, 0.27, 1.55) !important;
}

.scanner-view {
    overflow: hidden;
}

.slide-name-input:hover {
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/view/c240/c240_control_panel_view.css"],"names":[],"mappings":"AAAA;IACI,iCAAiC;IACjC,sBAAsB;IACtB,mBAAmB;IACnB,oCAAoC;IACpC,6BAA6B;AACjC;AACA;IACI,iCAAiC;IACjC,sBAAsB;IACtB,oCAAoC;IACpC,gBAAgB;AACpB;AACA;IACI,iCAAiC;IACjC,sBAAsB;IACtB,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,iCAAiC;AACrC;;AAEA;IACI,oBAAoB;IACpB,wBAAwB;IACxB,0BAA0B;IAC1B,+CAA+C;IAC/C,wBAAwB;IACxB,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;AACA;;GAEG;;AAEH;;IAEI,6FAA6F;AACjG;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".black-rounded-button{\n    background-color:black !important;\n    color:white !important;\n    border-radius: 50px;\n    border-color: transparent !important;\n    text-align: center !important;\n}\n.black-scan-btn{\n    background-color:black !important;\n    color:white !important;\n    border-color: transparent !important;\n    text-align: left;\n}\n.white-scan-btn{\n    background-color:white !important;\n    color:black !important;\n    border-color: transparent !important;\n    text-align: left;\n}\n\n.black-scan-btn:disabled{\n    color: white !important ;\n    background-color: gray !important;\n}\n\n.alter-order-button{\n    border:0 !important ;\n    height: 18px !important ;\n    padding: 0 3px !important ;\n    /*background-color: rgba(0,0,0,0) !important ;*/\n    color: white !important ;\n    background-color: gray !important;\n}\n\n.rounded-button{\n    border-radius: 50px;\n}\n\n.change-order-button{\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    margin-top: 5px;\n}\n\n.scan-btn{\n    /*border-radius: 50px;*/\n    width: 10vw;\n    text-align: left;\n}\n\n.custom-large-badge > .ant-badge-status-dot {\n    width: 9px;\n    height: 9px;\n}\n/* .ant-progress-circle-path{\n    stroke: #3ECD32 !important;\n} */\n\n.ant-badge-status-processing::after {\n    \n    animation: antStatusProcessing 1.2s infinite cubic-bezier(0.68, -0.55, 0.27, 1.55) !important;\n}\n\n.scanner-view {\n    overflow: hidden;\n}\n\n.slide-name-input:hover {\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
